import {CommonModule} from '@angular/common';
import {Component, Inject} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {TuiButton, TuiDialogContext} from '@taiga-ui/core';
import {POLYMORPHEUS_CONTEXT} from '@taiga-ui/polymorpheus';

export interface WhatsappQrCodeDialogData {
  qrCode: string;
}

@Component({
  selector: 'app-whatsapp-qr-code-dialog',
  standalone: true,
  imports: [CommonModule, TuiButton, TranslateModule],
  templateUrl: './whatsapp-qr-code-dialog.component.html',
})
export class WhatsappQrCodeDialogComponent {
  constructor(
    @Inject(POLYMORPHEUS_CONTEXT)
    private readonly context: TuiDialogContext<void, WhatsappQrCodeDialogData>,
  ) {}

  get data(): WhatsappQrCodeDialogData {
    return this.context.data;
  }

  close(): void {
    this.context.completeWith();
  }
}
